import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, findArrayObject, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import EditActionIcon from '../../components/Icons/EditActionIcon';
import DeleteActionIcon from '../../components/Icons/DeleteActionIcon';
import TripActionDialog from './TripActionDialog';
import {
  getTripDetailsV3,
  getVendorExpense,
  tripExpenseTypes
} from "../../../store/actions/tripActionCreator";
import DeleteTripExpense from './DeleteTripExpense';
import AddFuelExpenseDialog from '../VehicleDialogs/AddFuelExpenseDialog';

const useStyles = makeStyles((theme) => ({
  info: {
    padding: '12px 24px',
    borderRadius: 8
  },
  normal: {
    paddingLeft: 0,
    paddingBottom: 5,
    paddingTop: 5
  },
  normalProfit: {
    paddingLeft: 0,
    borderTop: '2px dotted rgba(107, 119, 140, 0.51)'
  },
  nested: {
    paddingLeft: 16,
    paddingBottom: 5,
    paddingTop: 5,
    paddingRight: 24
  },
  nestedNoAction: {
    paddingLeft: 16,
    paddingBottom: 5,
    paddingTop: 5,
    paddingRight: 80
  },
  primaryNormal: {
    fontSize: 18,
    fontWeight: 600
  },
  revenueNormalAmount: {
    color: '#0033cc',
    fontSize: 18
  },
  expenseNormalAmount: {
    //color:'red',
    fontSize: 18,
  },
  profitNormalAmount: {
    color: '#008556',
    fontSize: 18,
    fontWeight: 600
  },
  profitNegativeAmount: {
    color: 'red',
    fontSize: 18,
    fontWeight: 600
  },
  primaryNested: {
    fontSize: 16
  },
  primaryFreighNested: {
    fontSize: 16,
    fontWeight: 300
  },
  nestedAmount: {
    fontSize: 18
  },
  nestedAmountFreight: {
    fontSize: 16,
    fontWeight: 300
  }
}));
const ProfitSummary = (props) => {
  const { location, tripDetails, dispatchTripDetailsAction, dispatchGetVendorExpense, dispatchGetTripExpenseTypes, user } = props;
  const [open, setOpen] = React.useState(true);
  const [expenseItem, setExpenseItem] = useState(null);
  const [editTripActionOpen, setEditTripActionOpen] = useState(false);
  const [deleteTripExpenseOpen, setDeleteTripExpenseOpen] = useState(false);
  const [fuelExpenseDialogOpen, setFuelExpenseDialogOpen] = useState(false);
  const [expenseIdValue, setExpenseIdValue] = useState("");

  const handleClick = () => {
    setOpen(!open);
  };
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  const classes = useStyles();
  let editExpense = {
    action: 'edit_expense',
    label: 'Update Expense',
    tabsFormat: false
  }

  const editFuelExpenseData = {
    vehicleId: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.id ? user.singleTripData.vehicle.id : "",
    driverId: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.driverId ? user.singleTripData.vehicle.driverId : "",
    driverName: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.driverName ? user.singleTripData.vehicle.driverName : "",
    tripId: user && user.singleTripData && user.singleTripData.id ? user.singleTripData.id : ""
  }

  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  const handleActionEditExpense = (event, item) => {

    if (item && item.id) {
      dispatchGetTripExpenseTypes(() => {
        dispatchGetVendorExpense(item.id, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            if (response.response && response.response.id) {
              setExpenseItem(response.response);
              if (response.response.expenseType == "Fuel_Expense") {
                setFuelExpenseDialogOpen(true);
                setExpenseIdValue(response.response.id);
              }
              else {
                setEditTripActionOpen(true);
              }
            }
          }
        }, () => {

        })
      }, () => {

      })
    }
    /*let expenseItem;
    if (item && item.id && tripDetails && tripDetails.tripTransactions) {
      expenseItem = findArrayObject('id', item.id, tripDetails.tripTransactions)
    }
    if(expenseItem){
      setExpenseItem(expenseItem);
      setEditTripActionOpen(true);
    }*/
  }

  const handleActionDeleteExpense = (event, item) => {
    if (item && item.id) {
      dispatchGetVendorExpense(item.id, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          if (response.response && response.response.id) {
            setExpenseItem(response.response);
            setDeleteTripExpenseOpen(true);
          }
        }
      }, () => {

      })
    }
    /*let expenseItem;
    if (item && item.id && tripDetails && tripDetails.tripTransactions) {
      expenseItem = findArrayObject('id', item.id, tripDetails.tripTransactions)
    }
    if(expenseItem){
      setExpenseItem(expenseItem);
      setDeleteTripExpenseOpen(true);
    }*/
  }
  const handleaddTripActionClose = (status) => {
    setEditTripActionOpen(status);
    fetchTrip(tripId)
  }
  const handleOnUpdateSuccess = (status) => {
    setEditTripActionOpen(status);
    fetchTrip(tripId)
  }
  const onTripExpenseDeleteSucees = () => {
    fetchTrip(tripId)
    setDeleteTripExpenseOpen(false);
  }
  const onTripExpenseDeleteNo = () => {
    fetchTrip(tripId)
    setDeleteTripExpenseOpen(false);
  }

  const handleFuelExpenseClose = () => {
    setFuelExpenseDialogOpen(false);
    fetchTrip(tripId);
  }

  return (
    <Paper className={classes.info}>
      <List
        component="nav"
        aria-labelledby="profit-summary-list"
        className={classes.root}
      >
        <ListItem className={classes.normal}>
          <ListItemText primary="Revenue" classes={{ primary: classes.primaryNormal }} />
          <span className={classes.revenueNormalAmount}>{numberFormat(Number(tripDetails.profitSummaryRevenueAmount))}</span>
        </ListItem>
        {tripDetails.profitSummaryRevenue && <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {
              tripDetails.profitSummaryRevenue.map((item, index) => {
                return (<ListItem className={tripDetails && tripDetails.profitSummaryExpenses && tripDetails.profitSummaryExpenses.length > 0 && tripDetails.profitSummaryExpenses.some((item) => item && item.id ? true : false) ? classes.nestedNoAction : classes.nested}>
                  <ListItemText primary={item.displayName} classes={{ primary: item.displayName == 'Freight Amount' ? classes.primaryFreighNested : classes.primaryNested }} />
                  <span className={item.displayName == 'Freight Amount' ? classes.nestedAmountFreight : classes.nestedAmount}>{numberFormat(item.amount)}</span>
                </ListItem>)
              })
            }
          </List>
        </Collapse>}
        <ListItem className={classes.normal}>
          <ListItemText primary="Expenses" classes={{ primary: classes.primaryNormal }} />
          <span className={classes.expenseNormalAmount}>{numberFormat(Number(tripDetails.profitSummaryExpenseAmount))}</span>
        </ListItem>
        {tripDetails && tripDetails.profitSummaryExpenses && tripDetails.profitSummaryExpenses.length > 0 && <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {
              tripDetails.profitSummaryExpenses.map((item, index) => {
                return (item ? <ListItem key={index} className={item.id ? classes.nested : tripDetails.profitSummaryExpenses.length > 0 && tripDetails.profitSummaryExpenses.some((item) => item && item.id ? true : false) ? classes.nestedNoAction : classes.nested}>
                  <ListItemText primary={<span>{item.displayName} </span>} classes={{ primary: classes.primaryNested }} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{item.id && <><EditActionIcon onClick={(e) => { handleActionEditExpense(e, item) }} /><DeleteActionIcon onClick={(e) => { handleActionDeleteExpense(e, item) }} /></>}</span>
                </ListItem> : null);
              })
            }
            {/* {
              tripDetails.vendorTransactions.map((item,index)=>{
                return(item.transactionParentType=='EXPENSE'&&item.type!='Vehicle_Hire_Cost'?<ListItem key={index} className={classes.nested}>
                  <ListItemText primary={<span>{item.displayName} </span>} classes={{primary:classes.primaryNested}} />
                  <span className={classes.nestedAmount}>{numberFormat(item.amount)}{item.id && <><EditActionIcon onClick={(e)=>{}} /><DeleteActionIcon onClick={(e)=>{}} /></>}</span>
                </ListItem>:null);
              })
            } */}
          </List>
        </Collapse>}
        <ListItem className={classes.normalProfit}>
          <ListItemText primary="Profit" classes={{ primary: classes.primaryNormal }} />
          <span className={Number(tripDetails.profit) < 1 ? classes.profitNegativeAmount : classes.profitNormalAmount}>{numberFormat(Number(tripDetails.profit))}</span>
        </ListItem>
      </List>
      {editTripActionOpen && <TripActionDialog action={editExpense} editData={expenseItem} open={editTripActionOpen} onClose={handleaddTripActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={'Update Expense'} />}
      {deleteTripExpenseOpen && <DeleteTripExpense deleteOpen={deleteTripExpenseOpen} tripId={tripId} deleteId={expenseItem.id} onDeleteSucees={onTripExpenseDeleteSucees} onDeleteNo={onTripExpenseDeleteNo} />}
      {fuelExpenseDialogOpen && <AddFuelExpenseDialog open={fuelExpenseDialogOpen} fuelExpenseData={expenseItem} requestData={editFuelExpenseData} edit={true} expenseId={expenseIdValue} onClose={handleFuelExpenseClose} onConfirm={handleFuelExpenseClose} fromSingleTrip={true} />}
    </Paper>
  );
}
const ProfitSummaryWithRouter = withRouter(ProfitSummary);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
  dispatchGetVendorExpense: (expenseId, onSuccess, onFailure) =>
    dispatch(getVendorExpense(expenseId, onSuccess, onFailure)),
  dispatchGetTripExpenseTypes: (onSuccess, onFailure) => dispatch(tripExpenseTypes(onSuccess, onFailure)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfitSummaryWithRouter);
